module.exports = __webpack_public_path__ + "static/media/bgi-hiring-manager.a7d309b0.png";